export  default {
	timeago(time) {
	  var data = new Date(time);
	  var dateTimeStamp = data.getTime()
	  var minute = 1000 * 60;      //把分，时，天，周，半个月，一个月用毫秒表示
	  var hour = minute * 60;
	  var day = hour * 24;
	  var week = day * 7;
	  var month = day * 30;
	  var year = month * 12;
	  var now = new Date().getTime();   //获取当前时间毫秒
	  var diffValue = now - dateTimeStamp;//时间差

	  var result = "";
	  if (diffValue < 0) {
		result = "" + "未来";
	  }
	  var minC = diffValue / minute;  //计算时间差的分，时，天，周，月
	  var hourC = diffValue / hour;
	  var dayC = diffValue / day;
	  var weekC = diffValue / week;
	  var monthC = diffValue / month;
	  var yearC = diffValue / year;

	  if (yearC >= 1) {
		result = " " + parseInt(yearC) + "年前"
	  } else if (monthC >= 1 && monthC < 12) {
		result = " " + parseInt(monthC) + "月前"
	  } else if (weekC >= 1 && weekC < 5 && dayC > 6 && monthC < 1) {
		result = " " + parseInt(weekC) + "周前"
	  } else if (dayC >= 1 && dayC <= 7) {
		result = " " + parseInt(dayC) + "天前"
	  } else if (hourC >= 1 && hourC <= 23) {
		result = " " + parseInt(hourC) + "小时前"
	  } else if (minC >= 1 && minC <= 59) {
		result = " " + parseInt(minC) + "分钟前"
	  } else if (diffValue >= 0 && diffValue <= minute) {
		result = "刚刚"
	  }


	  return result
	},

	formatDate (data) {
	//    时间差 =现在的时间-过去的时间
	  const time = Date.now() - new Date(data) 
	  /* 
		1秒 1000
		1分钟 1000 * 60 60000 
		1小时 1000 * 60 * 60 3600000
		1天 1000 * 60 * 60 * 24 86400000
		1个月 1000 * 60 * 60 * 24 * 30 2592000000
		1年 1000 * 60 * 60 * 24 * 365 31536000000
	  */
	  const times = [31536000000, 2592000000, 86400000, 3600000, 60000, 1000]
	  const units = ['年前', '月前', '天前', '小时前', '分钟前', '秒前']
	  for (let i = 0; i < times.length; i++) {
		const res = time / times[i]
		
		if (res >= 1) {
			if( i == 5) {
				return '刚刚'
			}else{
				return Math.round(res) + units[i]
			}
		  
		}
	  }
	}
}


// WEBPACK FOOTER //
// ./src/common/js/formatTime.js